import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const IntroductionPageStyle = styled('div')`
    ${typography.bodyMd}
    .text-signature {
        font-family: 'The Nautigal', cursive;
        font-size: 44.196px;
        font-weight: 400;
        line-height: 44.196px;
    }
    .color-success {
        color: var(--orange-300);
    }
    .text-line {
        text-decoration-line: underline;
    }

    .intro-title {
        ${typography.subhead}
        margin-bottom: 24px;
    }
    .box-line {
        margin-bottom: 24px;
        border-bottom: 1px solid var(--sand-400);
        padding-bottom: 48px;
    }
    .box-intro {
        border-radius: 6px;
        border: 1px solid var(--sand-400);
        background: var(--white);
        padding: 32px;
        color: var(--sand-700);
        margin-bottom: 36px;

        .m-bottom {
            margin-bottom: 20px;
        }

        .info-seller {
            display: flex;
            justify-content: space-between;
            align-items: end;
            text-align: right;
            font-weight: 900;
        }
    }

    .box-about {
        .consultant {
            text-align: right;
            font-weight: 900;
        }

        .detail {
            margin-bottom: 16px;
        }
    }

    .ready-book {
        padding: 30px;
        background: var(--sand-300);
        margin-bottom: 40px;
        margin-top: 20px;
        font-size: 16px;

        .title-ready {
            color: var(--sand-700);
            font-size: 24px;
            font-weight: 900;
        }

        .btn-pay {
            background-color: var(--orange-300) !important;
            width: 100%;
            height: 56px;
            font-weight: 900;
            font-size: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            color: var(--white);
            margin: 16px 0;
            padding: 10px;
            text-align: center;
        }
    }

    .box-cart {
        background-color: var(--white);
        border: 1px solid var(--sand-400);
        border-radius: 6px;
        padding: 2rem;
        position: relative;
        margin-bottom: 24px;
        color: var(--sand-700);

        .title {
            font-size: 24px;
            font-weight: 700;
        }
        .sub-title {
            font-size: 20px;
            font-weight: 700;
            margin: 16px 0;
        }

        .group {
            display: none;
        }

        .viewPayment {
            font-size: 18px;
        }

        &.edit {
            border: 2px solid var(--orange-300);
            padding: 16px;
        }

        .iconAddComment {
            position: absolute;
            right: 0;
            top: 50%;
            margin-right: -25px;
            margin-top: -25px;
            cursor: pointer;
            transition: all 0.2s;
            z-index: 5;
            &:hover {
                transform: scale(1.1);
            }
        }
    }

    @media screen and (min-width: 992px) {
        .max-w {
            width: calc(100% - 100px);
        }
    }

    @media screen and (max-width: 767px) {
        .box-intro {
            .info-seller {
                flex-direction: column;
            }
        }
    }

    @media print {
        .box-intro,
        .box-line,
        .box-about {
            break-inside: avoid;
            page-break-inside: avoid;
            margin-top: 24px;
        }
    }
`;
export default IntroductionPageStyle;
